import {Component, ElementRef, Inject, LOCALE_ID, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProgressService} from '../../service/progress.service';
import {BaseModalComponent} from '../../common/modal/base-modal/base-modal.component';
import {EditorComponent} from '@tinymce/tinymce-angular';
import {Contest} from '../../model/contest/Contest';
import {UrlHelper} from '../../helper/url.helper';
import {Locale} from '../../model/Locale';
import {TenantService} from '../../service/tenant.service';
import {environment} from '../../../environments/environment';
import {CopyDataHelper} from '../../helper/copy-data.helper';

export interface ContestDetailsData {
  competitionId: string;
  contest?: Contest;
}

@Component({
  selector: 'app-contest-direct-url-modal',
  templateUrl: './contest-direct-url-modal.component.html',
  styleUrls: ['./contest-direct-url-modal.component.scss'],
})
export class ContestDirectUrlModalComponent extends BaseModalComponent {

  @ViewChild('dialogContent', {static: true}) protected progressContainer!: ElementRef;
  @ViewChild('editorComponent', {static: true}) editor!: EditorComponent;

  readonly competitionId?: string;
  readonly contest?: Contest;
  readonly langUrl: string;
  readonly domainPrefix?: string;

  constructor(dialogRef: MatDialogRef<ContestDirectUrlModalComponent>,
              progressService: ProgressService,
              @Inject(MAT_DIALOG_DATA) data: ContestDetailsData,
              @Inject(LOCALE_ID) private locale: string) {
    super(dialogRef, progressService);

    this.competitionId = data?.competitionId;
    this.contest = data?.contest;
    this.langUrl = (locale as Locale) == Locale.uk ? UrlHelper.DEFAULT_UK_PATH : UrlHelper.DEFAULT_EN_PATH;
    this.domainPrefix = TenantService.getSubdomain();
  }

  get getExamUrl(): string {
    const urlPref = `https://${this.domainPrefix ? this.domainPrefix + '.' : ''}${environment.ui.host}${this.langUrl}`;

    return this.contest
      ? `${urlPref}${UrlHelper.CONTEST_EXAM_PATH}${this.contest.id}`
      : '';
  }

  proceed(): void {
  }

  proceedAllowed(): boolean {
    return true;
  }

  copyMessage(val: string) {
    CopyDataHelper.copyMessage(val);
  }
}
